const html2pdf = require('html2pdf.js');
const moment = require("moment");

class ReportManager {
    urlExport;
    urlFetchTabularData;
    urlFetchChartData;
    flatpickr;
    defaultStartDate;
    defaultEndDate;
    sort;
    sortDir = 'desc';
    viewType = 'tabular';
    eventChartType = 'bar';
    engagementSeriesTotal;
    engagementMetricsChart;
    engagementMetricsChartOptions;
    lineSeriesShouldGroupByWeek;
    lineChart;
    lineChartSeries;
    lineChartSeriesVisibility;
    lineChartOptions;
    pieChartOptions;
    pieChartEmail;
    pieChartEmailSeries;
    pieChartSms;
    pieChartSmsSeries;
    pieChartVideo;
    pieChartVideoSeries;

    constructor(urlExport, urlFetchTabularData) {
        let self = this;

        this.urlExport = urlExport;
        this.urlFetchTabularData = urlFetchTabularData;
        this.urlFetchChartData = urlFetchChartData;
        this.flatpickr = null;
        this.engagementMetricsChart = null;
        this.engagementSeriesTotal = 0;
        this.engagementMetricsChartOptions = {
            chart: {
                type: 'bar',
                fontFamily: 'inherit',
                toolbar: {
                    show: false,
                },
            },
            plotOptions: {
                bar: {
                    distributed: true,
                    dataLabels: {
                        position: 'top',
                    },
                },
            },
            dataLabels: {
                enabled: true,
                offsetY: -25,
                formatter: function (val) {
                    if (self.engagementSeriesTotal === 0) {
                        return '0%';
                    }

                    return (
                        Math.round(Math.abs((val * 100) / self.engagementSeriesTotal) * 1000) /
                        1000 +
                        '%'
                    );
                },
                style: {
                    fontSize: '12px',
                    colors: ['#304758'],
                },
            },
            colors: ['#4ADE80', '#8B5CF6', '#3B82F6', '#F59E0B'],
            xaxis: {
                categories: ['Sent', 'Delivered', 'Opened', 'Clicked'],
                labels: {
                    style: {
                        fontSize: '12px',
                    },
                },
            },
            yaxis: {
                tickAmount: 5,
                labels: {
                    formatter: function (val) {
                        return val.toFixed(0);
                    },
                },
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val;
                    },
                },
            },
            legend: {
                show: false,
            },
            series: [{
                name: 'Engagement',
                data: [0, 0, 0, 0]
            }]
        };

        this.lineChart = null;
        this.lineChartSeries = [];
        this.lineChartSeriesVisibility = {
            email: true,
            sms: true,
            video: true,
            exports: false,
        };
        this.lineChartOptions = {
            chart: {
                type: 'line',
                fontFamily: 'inherit',
                toolbar: {
                    show: false,
                },
            },
            stroke: {
                curve: 'smooth',
                width: 3,
            },
            colors: ['#3B82F6', '#F59E0B', '#8B5CF6', '#10B981'],
            markers: {
                size: 2,
                strokeColors: ['#3B82F6', '#F59E0B', '#8B5CF6', '#10B981'],
                strokeWidth: 2,
            },
            xaxis: {
                categories: [],
                labels: {
                    style: {
                        fontSize: '12px',
                    },
                    rotateAlways: self.lineSeriesShouldGroupByWeek,
                    rotate: -45,
                    trim: false,
                },
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        return val.toFixed(0);
                    },
                },
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val;
                    },
                },
            },
            legend: {
                show: true,
                position: 'top',
                horizontalAlign: 'right',
                floating: false
            },
            series: []
        };

        this.pieChart = null;
        this.pieChartEmailSeries = [];
        this.pieChartSmsSeries = [];
        this.pieChartVideoSeries = [];
        this.pieChartOptions = {
            chart: {
                type: 'pie',
                fontFamily: 'inherit',
                toolbar: {
                    show: false,
                },
            },
            labels: ['Opened', 'Active', 'Engaged'],
            colors: ['#69D48E', '#3CADEE', '#C5EAFF'],
            legend: {
                show: false,
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val;
                    },
                },
            },
            dataLabels: {
                formatter: function (val) {
                    return val.toFixed(1) + '%';
                },
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                        },
                    },
                },
            ],
            series: [],
        };
    }

    init() {
        this.initMultiselect();
        this.initDatePickers();
        this.initPagination();
        this.initSearchControl();
        this.initFilterControl();
        this.initResetControl();
        this.initExportControl();
        this.initSortControl();
        this.initChartTypeControl();
        this.initToggleViewControl();
        this.initLineSeriesVisibilityControl();
        this.initChartToggleTypeButtonControl();
        this.initChart();

        this.toggleView('tabular');

        this.getTabularData();
        this.getChartData();
    }

    getDateParams() {
        if (this.flatpickr && this.flatpickr.selectedDates.length === 2) {
            return {
                fromDate: moment(this.flatpickr.selectedDates[0]).format('MM/DD/YYYY'),
                toDate: moment(this.flatpickr.selectedDates[1]).format('MM/DD/YYYY')
            }
        }

        return {
            fromDate: '',
            toDate: ''
        };
    }

    initMultiselect() {
        $("select[multiple]").multiselect({
            buttonTextAlignment: 'left',
        });

        $('.dropdown-toggle').on('click', function(e) {
            if (!$(this).next().hasClass('show')) {
                $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
            }

            const $subMenu = $(this).next('.dropdown-menu');
            $subMenu.toggleClass('show');

            return false;
        });
    }

    initSearchControl() {
        $("#search").on('keypress', (e) => {
            if (e.which === 13) {
                this.getTabularData();
                this.getChartData();
            }
        })
    }

    initDatePickers() {
        this.flatpickr = $('#dates').flatpickr({
            mode: 'range',
            dateFormat: "Y-m-d",
            onOpen: function (selectedDates, dateStr, instance) {
                instance.config.maxDate = $("#to").val();
            }
        });

        if (this.flatpickr && this.flatpickr.selectedDates) {
            this.defaultStartDate = this.flatpickr.selectedDates[0];
            this.defaultEndDate = this.flatpickr.selectedDates[1];
        }
    }

    initPagination() {
        $(document).on('click', '.pagination li a', (e) => {
            e.preventDefault();

            const url = $(e.target).attr('href');

            App.loadAjax();

            $.get(url, this.getDateParams(), (response) => {
                document.querySelector('.customer-table-holder').innerHTML = response.tableData;

                App.loadAjax('unmask');

                this.initSortControl();
            });
        });
    }

    initFilterControl() {
        $('#btn-submit-filter').click(() => {
            this.getTabularData();
            this.getChartData();
            $('.dropdown-menu.show').removeClass('show');
        });
    }

    initResetControl() {
        $('#btn-reset-filter').click(() => {
            $('#campaign_name').val('');
            $('#status option:selected').each(function () {
                $(this).prop('selected', false);
            });
            $('#event_type option:selected').each(function () {
                $(this).prop('selected', false);
            });

            $('#status').multiselect('refresh');
            $('#event_type').multiselect('refresh');
            $("#dates").val('');

            this.flatpickr.setDate('');
        });
    }

    initExportControl() {
        $('#btn-submit-export').click(() => {
            if (this.viewType === 'tabular') {
                this.exportTabularData();
            } else {
                this.exportViewData();
            }
        });
    }

    initSortControl() {
        const self = this;

        $('.btn-sort').click(function () {
            const sort = $(this).data('sort');

            if (self.sort === sort) {
                self.sortDir = self.sortDir === 'asc' ? 'desc' : 'asc';
            } else {
                self.sort = sort;
                self.sortDir = 'desc';
            }

            self.getTabularData();
        })
    }

    initChartTypeControl() {
        $('input[name=chart_type]').change((e) => {
            this.refreshChart($(e.target));
        });
    }

    initToggleViewControl() {
        $('input[name=view_type]').change((e) => {
            this.toggleView($(e.target).val());
        });
    }

    initLineSeriesVisibilityControl() {
        $('input[name=line_series_visibility]').change((e) => {
            this.lineChartSeriesVisibility[$(e.target).val()] = $(e.target).is(':checked');
            this.refreshLineChart();
        });
    }

    initChartToggleTypeButtonControl() {
        const $button = $('#btn-toggle-event-chart');
        const toggle = () => {
            if (this.eventChartType === 'bar') {
                $('.bar-chart-bars').hide();
                $('.pie-chart').show();
                $button.text('Switch to Bar Chart');

                this.eventChartType = 'pie';
            } else {
                $('.pie-chart').hide();
                $('.bar-chart-bars').show();
                $button.text('Switch to Pie Chart');

                this.eventChartType = 'bar';
            }
        };

        $button.click(toggle);

        toggle();
    }

    initChart() {
        this.engagementMetricsChart = new ApexCharts(document.querySelector("#engagement-metrics-chart"), this.engagementMetricsChartOptions);
        this.engagementMetricsChart.render();
        this.lineChart = new ApexCharts(document.querySelector("#line-chart"), this.lineChartOptions);
        this.lineChart.render();
        this.pieChartEmail = new ApexCharts(document.querySelector("#pie-chart-email"), {...this.pieChartOptions, series: this.pieChartEmailSeries});
        this.pieChartEmail.render();
        this.pieChartSms = new ApexCharts(document.querySelector("#pie-chart-sms"), {...this.pieChartOptions, series: this.pieChartSmsSeries});
        this.pieChartSms.render();
        this.pieChartVideo = new ApexCharts(document.querySelector("#pie-chart-video"), {...this.pieChartOptions, series: this.pieChartVideoSeries});
        this.pieChartVideo.render();
    }

    refreshEngagementMetricsChart() {
        this.engagementMetricsChart.destroy();
        this.engagementMetricsChart = new ApexCharts(document.querySelector("#engagement-metrics-chart"), this.engagementMetricsChartOptions);
        this.engagementMetricsChart.render();
    }

    refreshLineChart() {
        const lineChartSeries = [];
        const lineChartSeriesLabels = {
            email: 'Email',
            sms: 'SMS',
            video: 'Video',
            exports: 'Exports',
        };

        Object.keys(this.lineChartSeriesVisibility).forEach((key) => {
            if (this.lineChartSeriesVisibility[key]) {
                lineChartSeries.push({
                    name: lineChartSeriesLabels[key],
                    data: this.lineChartSeries[key],
                });
            }
        });

        this.lineChartOptions.series = lineChartSeries;
        this.lineChart.destroy();
        this.lineChart = new ApexCharts(document.querySelector("#line-chart"), this.lineChartOptions);
        this.lineChart.render();
    }

    refreshPieChart() {
        this.pieChartEmail.destroy();
        this.pieChartEmail = new ApexCharts(document.querySelector("#pie-chart-email"), {...this.pieChartOptions, series: this.pieChartEmailSeries});
        this.pieChartEmail.render();
        this.pieChartSms.destroy();
        this.pieChartSms = new ApexCharts(document.querySelector("#pie-chart-sms"), {...this.pieChartOptions, series: this.pieChartSmsSeries});
        this.pieChartSms.render();
        this.pieChartVideo.destroy();
        this.pieChartVideo = new ApexCharts(document.querySelector("#pie-chart-video"), {...this.pieChartOptions, series: this.pieChartVideoSeries});
        this.pieChartVideo.render();
    }

    refreshChart() {
        this.refreshEngagementMetricsChart();
        this.refreshLineChart();
        this.refreshPieChart();
    }

    groupDataByWeek(data) {
        const result = {};
        const dates = Object.keys(data);

        if (!dates.length) {
            return {};
        }

        dates.sort((a, b) => new Date(a).getTime() - new Date(b).getTime());

        let currentWeekStart = new Date(dates[0]);
        let currentWeekLabel = `${currentWeekStart.toISOString().substring(0, 10)}`;
        let currentWeekSum = 0;

        dates.forEach((date) => {
            const currentDate = new Date(date);
            const daysDiff = Math.floor(
                (currentDate.getTime() - currentWeekStart.getTime()) /
                (1000 * 60 * 60 * 24)
            );

            if (daysDiff < 7) {
                currentWeekSum += data[date] || 0;
            } else {
                result[currentWeekLabel] = currentWeekSum;
                currentWeekStart = new Date(date);
                currentWeekLabel = `${currentWeekStart.toISOString().substring(0, 10)}`;
                currentWeekSum = data[date] || 0;
            }
        });

        result[currentWeekLabel] = currentWeekSum;

        return result;
    };

    getFilters() {
        const { fromDate, toDate } = this.getDateParams();
        const inputCampaign = $('#campaign_name').val();
        const inputStatus = $('#status').val();
        const inputEventType = $('#event_type').val();
        const inputSearch = $("#search").val();
        let params = [];

        if (fromDate && toDate) {
            params.push('from=' + fromDate);
            params.push('to=' + toDate);
        }

        if (inputCampaign) {
            params.push('name=' + inputCampaign);
        }

        if (inputSearch) {
            params.push('search=' + inputSearch);
        }

        if (inputStatus && inputStatus.length) {
            const statusArray = Array.isArray(inputStatus) ? inputStatus : inputStatus.split(',').map(s => s.trim());
            statusArray.filter(status => !!status)
                .forEach(status => params.push(`status[]=${encodeURIComponent(status)}`));
        }

        if (inputEventType && inputEventType.length) {
            const eventTypeArray = Array.isArray(inputEventType) ? inputEventType : inputEventType.split(',').map(e => e.trim());
            eventTypeArray.filter(eventType => !!eventType)
                .forEach(eventType => params.push(`event_type[]=${encodeURIComponent(eventType)}`));
        }

        if (this.sort && this.sortDir) {
            params.push('sort=' + this.sort);
            params.push('sort_dir=' + this.sortDir);
        }

        return params.join('&');
    }

    exportViewData() {
        App.loadAjax();
        const pdfOption = {
            margin: 1,
            filename: 'Campaign_Analytics_' + moment().format('yyyy-MM-DD-HH-mm-ss') + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
                scale: 1.5,
                useCORS: true,
                logging: true,
                letterRendering: true,
            },
            jsPDF: { unit: 'in', format: 'a3', orientation: 'landscape' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        };

        html2pdf()
            .set(pdfOption)
            .from(document.getElementById('chart-view'))
            .save();

        App.loadAjax('unmask');
    }

    exportTabularData() {
        App.loadAjax();

        const url = this.urlExport + '?' + this.getFilters();

        $.ajax({
            url: url,
            method: 'GET',
            xhrFields: {
                responseType: 'blob'
            },
            success: function (data, status, xhr) {
                let filename = "exported_data.xlsx";
                let disposition = xhr.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    let matches = /filename="([^"]+)"/.exec(disposition);
                    if (matches && matches[1]) filename = matches[1];
                }

                let link = document.createElement('a');
                let url = window.URL.createObjectURL(data);
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
                link.remove();

                App.loadAjax('unmask');
            },
            error: function () {
                alert('Download failed.');
                App.loadAjax('unmask');
            }
        });
    }

    getTabularData() {
        App.loadAjax();

        const url = this.urlFetchTabularData + '?' + this.getFilters();

        $.getJSON(url, (response) => {
            document.querySelector('.customer-table-holder').innerHTML = response.tableData;

            $('#btn-submit-export').attr('disabled', $(".customer-table-holder tbody tr").length === 0);

            App.loadAjax('unmask');

            this.initSortControl();
        });
    }

    getChartData() {
        const url = this.urlFetchChartData + '?' + this.getFilters();

        $.getJSON(url, (response) => {
            const engagementMetrics = response.engagementMetrics || [];
            this.engagementSeriesTotal = engagementMetrics.sent + engagementMetrics.delivered + engagementMetrics.opened + engagementMetrics.clicked;
            this.engagementMetricsChartOptions.series = [
                {
                    name: 'Engagement',
                    data: [
                        engagementMetrics.sent,
                        engagementMetrics.delivered,
                        engagementMetrics.opened,
                        engagementMetrics.clicked,
                    ]
                }
            ];

            const dailyTrendsMetrics = response.dailyTrends || [];
            const categories = [];
            const seriesData = {
                email: [],
                sms: [],
                video: [],
                exports: [],
            };

            const shouldGroupByWeek = Object.keys(dailyTrendsMetrics).length > 14;
            const groupedData = {
                email: {},
                sms: {},
                video: {},
                exports: {},
            };

            if (shouldGroupByWeek) {
                Object.keys(dailyTrendsMetrics).forEach((date) => {
                    const trend = dailyTrendsMetrics[date];
                    if (trend.email) {
                        groupedData.email[date] = trend.email;
                    }
                    if (trend.sms) {
                        groupedData.sms[date] = trend.sms;
                    }
                    if (trend.video) {
                        groupedData.video[date] = trend.video;
                    }
                    if (trend.exports) {
                        groupedData.exports[date] = trend.exports;
                    }
                });

                const groupedEmail = this.groupDataByWeek(groupedData.email);
                const groupedSMS = this.groupDataByWeek(groupedData.sms);
                const groupedVideo = this.groupDataByWeek(groupedData.video);
                const groupedExports = this.groupDataByWeek(groupedData.exports);

                const allWeeks = new Set([
                    ...Object.keys(groupedEmail),
                    ...Object.keys(groupedSMS),
                    ...Object.keys(groupedVideo),
                    ...Object.keys(groupedExports),
                ]);

                const sortedWeeks = Array.from(allWeeks).sort(
                    (a, b) => new Date(a).getTime() - new Date(b).getTime()
                );

                sortedWeeks.forEach((week) => {
                    categories.push(`${moment(week).format('DD MMM')}`);
                    seriesData.email.push(groupedEmail[week] || 0);
                    seriesData.sms.push(groupedSMS[week] || 0);
                    seriesData.video.push(groupedVideo[week] || 0);
                    seriesData.exports.push(groupedExports[week] || 0);
                });
            } else {
                const sortedDates = Object.keys(dailyTrendsMetrics).sort(
                    (a, b) => new Date(a).getTime() - new Date(b).getTime()
                );

                sortedDates.forEach((date) => {
                    const trend = dailyTrendsMetrics[date];

                    categories.push(date);
                    seriesData.email.push(trend.email || 0);
                    seriesData.sms.push(trend.sms || 0);
                    seriesData.video.push(trend.video || 0);
                    seriesData.exports.push(trend.exports || 0);
                });
            }

            this.lineChartSeries = seriesData;
            this.lineSeriesShouldGroupByWeek = shouldGroupByWeek;
            this.lineChartOptions.xaxis.categories = categories;
            this.lineChartOptions.xaxis.labels.rotateAlways = shouldGroupByWeek;

            const eventStatsEmailActive = response.eventStats.email_active || 0;
            const eventStatsEmailEngaged = response.eventStats.email_engaged || 0;
            const eventStatsEmailOpened = response.eventStats.email_opened || 0;
            const eventStatsEmailTotal = eventStatsEmailActive + eventStatsEmailEngaged + eventStatsEmailOpened;
            const eventStatsSmsActive = response.eventStats.sms_active || 0;
            const eventStatsSmsEngaged = response.eventStats.sms_engaged || 0;
            const eventStatsSmsOpened = response.eventStats.sms_opened || 0;
            const eventStatsSmsTotal = eventStatsSmsActive + eventStatsSmsEngaged + eventStatsSmsOpened;
            const eventStatsVideoActive = response.eventStats.video_active || 0;
            const eventStatsVideoEngaged = response.eventStats.video_engaged || 0;
            const eventStatsVideoOpened = response.eventStats.video_opened || 0;
            const exportStatsExports = response.eventStats.exports || 0;
            const exportStatsGoogleAds = response.eventStats.google_ads || 0;
            const exportStatsFacebookAds = response.eventStats.fb_ads || 0;
            const eventStatsVideoTotal = eventStatsVideoActive + eventStatsVideoEngaged + eventStatsVideoOpened;
            const eventStatsEmailOpenedPercent = eventStatsEmailTotal === 0 ? 0 : (eventStatsEmailOpened / eventStatsEmailTotal) * 100;
            const eventStatsEmailActivePercent = eventStatsEmailTotal === 0 ? 0 : (eventStatsEmailActive / eventStatsEmailTotal) * 100;
            const eventStatsEmailEngagedPercent = eventStatsEmailTotal === 0 ? 0 : (eventStatsEmailEngaged / eventStatsEmailTotal) * 100;
            const eventStatsSmsOpenedPercent = eventStatsSmsTotal === 0 ? 0 : (eventStatsSmsOpened / eventStatsSmsTotal) * 100;
            const eventStatsSmsActivePercent = eventStatsSmsTotal === 0 ? 0 : (eventStatsSmsActive / eventStatsSmsTotal) * 100;
            const eventStatsSmsEngagedPercent = eventStatsSmsTotal === 0 ? 0 : (eventStatsSmsEngaged / eventStatsSmsTotal) * 100;
            const eventStatsVideoOpenedPercent = eventStatsVideoTotal === 0 ? 0 : (eventStatsVideoOpened / eventStatsVideoTotal) * 100;
            const eventStatsVideoActivePercent = eventStatsVideoTotal === 0 ? 0 : (eventStatsVideoActive / eventStatsVideoTotal) * 100;
            const eventStatsVideoEngagedPercent = eventStatsVideoTotal === 0 ? 0 : (eventStatsVideoEngaged / eventStatsVideoTotal) * 100;

            $("#event-stats-email-total").text(eventStatsEmailTotal);
            $("#event-stats-sms-total").text(eventStatsSmsTotal);
            $("#event-stats-video-total").text(eventStatsVideoTotal);
            $("#export-stats-exports-total").text(exportStatsExports);
            $("#export-stats-google-total").text(exportStatsGoogleAds);
            $("#export-stats-facebook-total").text(exportStatsFacebookAds);
            $("#event-stats-bar-email-opened > .bar-chart-value").css("width", `${eventStatsEmailOpenedPercent}%`);
            $("#event-stats-bar-email-opened > .bar-chart-text").text(`${eventStatsEmailOpenedPercent.toFixed(2)}%`);
            $("#event-stats-bar-email-active > .bar-chart-value").css("width", `${eventStatsEmailActivePercent}%`);
            $("#event-stats-bar-email-active > .bar-chart-text").text(`${eventStatsEmailActivePercent.toFixed(2)}%`);
            $("#event-stats-bar-email-engaged > .bar-chart-value").css("width", `${eventStatsEmailEngagedPercent}%`);
            $("#event-stats-bar-email-engaged > .bar-chart-text").text(`${eventStatsEmailEngagedPercent.toFixed(2)}%`);
            $("#event-stats-bar-sms-opened > .bar-chart-value").css("width", `${eventStatsSmsOpenedPercent}%`);
            $("#event-stats-bar-sms-opened > .bar-chart-text").text(`${eventStatsSmsOpenedPercent.toFixed(2)}%`);
            $("#event-stats-bar-sms-active > .bar-chart-value").css("width", `${eventStatsSmsActivePercent}%`);
            $("#event-stats-bar-sms-active > .bar-chart-text").text(`${eventStatsSmsActivePercent.toFixed(2)}%`);
            $("#event-stats-bar-sms-engaged > .bar-chart-value").css("width", `${eventStatsSmsEngagedPercent}%`);
            $("#event-stats-bar-sms-engaged > .bar-chart-text").text(`${eventStatsSmsEngagedPercent.toFixed(2)}%`);
            $("#event-stats-bar-video-opened > .bar-chart-value").css("width", `${eventStatsVideoOpenedPercent}%`);
            $("#event-stats-bar-video-opened > .bar-chart-text").text(`${eventStatsVideoOpenedPercent.toFixed(2)}%`);
            $("#event-stats-bar-video-active > .bar-chart-value").css("width", `${eventStatsVideoActivePercent}%`);
            $("#event-stats-bar-video-active > .bar-chart-text").text(`${eventStatsVideoActivePercent.toFixed(2)}%`);
            $("#event-stats-bar-video-engaged > .bar-chart-value").css("width", `${eventStatsVideoEngagedPercent}%`);
            $("#event-stats-bar-video-engaged > .bar-chart-text").text(`${eventStatsVideoEngagedPercent.toFixed(2)}%`);
            $("#export-stats-bar-exports > .bar-chart-value").css("width", exportStatsExports > 0 ? "100%" : "0%");
            $("#export-stats-bar-exports > .bar-chart-text").text(exportStatsExports > 0 ? "100%" : "0%");
            $("#export-stats-bar-google > .bar-chart-value").css("width", exportStatsGoogleAds > 0 ? "100%" : "0%");
            $("#export-stats-bar-google > .bar-chart-text").text(exportStatsGoogleAds > 0 ? "100%" : "0%");
            $("#export-stats-bar-facebook > .bar-chart-value").css("width", exportStatsFacebookAds > 0 ? "100%" : "0%");
            $("#export-stats-bar-facebook > .bar-chart-text").text(exportStatsFacebookAds > 0 ? "100%" : "0%");

            this.pieChartEmailSeries = [
                eventStatsEmailOpened,
                eventStatsEmailActive,
                eventStatsEmailEngaged,
            ];
            this.pieChartSmsSeries = [
                eventStatsSmsOpened,
                eventStatsSmsActive,
                eventStatsSmsEngaged,
            ];
            this.pieChartVideoSeries = [
                eventStatsVideoOpened,
                eventStatsVideoActive,
                eventStatsVideoEngaged,
            ];

            this.refreshChart();
        });
    }

    toggleView(viewType) {
        this.viewType = viewType;

        if (this.viewType === 'chart') {
            $('#btn-submit-export > span').text('Export PDF');
            $('#tabular-view').removeClass('hidden').hide();
            $('#chart-view').removeClass('hidden').show();
        } else {
            $('#btn-submit-export > span').text('Export CSV');
            $('#chart-view').removeClass('hidden').hide();
            $('#tabular-view').removeClass('hidden').show();
        }
    }
}

window.ReportManager = ReportManager;
module.exports = ReportManager;
